export const MerchantSelectionConfirmDialogStyles = {
  dialog: 'w-3/4 shadow-md bg-white rounded-md max-w-4xl p-9 md:p-10'
}
